import { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import '../styles/TabsLayout.css';

const TabsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('inicio');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Carregar estado do sidebar
  useEffect(() => {
    const savedState = localStorage.getItem('sidebarCollapsed');
    if (savedState !== null && !isMobile) {
      setSidebarCollapsed(JSON.parse(savedState));
    }
  }, [isMobile]);

  const handleToggleSidebar = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
  };

  const getActiveTabFromPath = (pathname) => {
    if (pathname === '/' || pathname === '/inicio') return 'inicio';
    if (pathname.includes('/historico')) return 'historico';
    if (pathname.includes('/perfil')) return 'perfil';
    return 'inicio';
  };

  useEffect(() => {
    const tab = getActiveTabFromPath(location.pathname);
    setActiveTab(tab);
  }, [location.pathname]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    
    switch (tab) {
      case 'inicio':
        navigate('/');
        break;
      case 'historico':
        navigate('/historico');
        break;
      case 'perfil':
        navigate('/perfil');
        break;
      default:
        navigate('/');
    }
  };

  return (
    <div className="tabs-layout-modern">
      <Sidebar 
        activeTab={activeTab} 
        onTabChange={handleTabChange}
        collapsed={sidebarCollapsed && !isMobile}
        onToggleCollapse={handleToggleSidebar}
      />
      
      <main className={`main-content ${sidebarCollapsed && !isMobile ? 'expanded' : ''}`}>
        <div className="content-header">
          <h1 className="page-title">
            {activeTab === 'inicio' && 'Dashboard'}
            {activeTab === 'historico' && 'Histórico'}
            {activeTab === 'perfil' && 'Perfil'}
          </h1>
        </div>
        
        <div className="content-area">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default TabsLayout;